import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { fetchRemoveToCartItem } from "../../actions/global";

const formattedPrice = (price) => {
  if (price == null || price === "") return "0,00";

  // Pretvori u broj
  const number = Number(price);

  // Formatiraj sa hiljadarkama i dve decimale
  return number
    .toFixed(2) // obavezno dve decimale
    .replace(".", ",") // decimalna tačka → zarez
    .replace(/\B(?=(\d{3})+(?!\d))/g, "."); // hiljadarke tačka
};

function formatUrlString(inputString) {
  // Pretvara sva velika slova u mala
  const lowercaseString = inputString.toLowerCase();

  // Zamjenjuje sve razmake i specijalne karaktere sa -
  const formattedString = lowercaseString
    .replace(/[^\w\s]/gi, "")
    .replace(/\s+/g, "-");

  return formattedString;
}

const CartItem = (props) => {
  const dispatch = useDispatch();
  const { item } = props || {};
  const removeCartItem = () => {
    const dataValue = {
      productId: item?.id,
      quantity: item?.quantity,
    };

    dispatch(fetchRemoveToCartItem(dataValue));
  };

  return (
    <tr>
      <td class="image-content-cart-item-name">
        <Link to={`/proizvod/${formatUrlString(item.name)}/${item.id}`}>
          <div class="image-content-cart-item-name-holder">
            <img src={item?.images?.[0]} class="img-fluid" alt="Fuka" />
            <h5>{item?.name}</h5>
          </div>
        </Link>
      </td>
      <td class="text-end mobile-width-column">
        <div class="mobile-width-column">
          {formattedPrice(item?.cashPrice)} RSD
        </div>
      </td>
      <td class="text-end">{item?.quantity}</td>
      <td class="table-cart-item-subtotal">
        <div class="mobile-width-column">
          {formattedPrice(item?.cashPrice * item?.quantity)} RSD
        </div>
      </td>
      <td class="table-cart-item-remove" onClick={() => removeCartItem()}>
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="xmark"
          class="svg-inline--fa fa-xmark "
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 384 512"
        >
          <path
            fill="currentColor"
            d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
          ></path>
        </svg>
      </td>
    </tr>
  );
};

export default CartItem;
